import { useState, useEffect, useCallback } from "react";
import { RouterProvider } from "react-router";
import { router } from "./routes";
import { config } from "./config";
import {
  DuviSharedAdminAuthProvider,
  DuviSharedAdminErrorBoundary,
  DuviSharedAdminSessionExpiredDialog,
  duviSharedAdminSetSessionExpiredHandler,
} from "@duvi-agency/auth";
import { DuviCoreAdminToastProvider } from "./components/duvi-core-admin-kit";

const authConfig = {
  brandName: "Duvi Platform",
  authUrl: config.authUrl,
  apiUrl: config.apiUrl,
};

export default function App() {
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    duviSharedAdminSetSessionExpiredHandler(() => setSessionExpired(true));
    return () => duviSharedAdminSetSessionExpiredHandler(() => {});
  }, []);

  const handleSessionExpiredConfirm = useCallback(() => {
    setSessionExpired(false);
    // Hard-reload to the SPA root. The root route renders the login
    // entry directly, so this guarantees the SPA loads (and not the
    // edge's auth-API integration on `/auth`) and gives the auth
    // provider a clean reinitialisation. See bug 0038 for context.
    window.location.href = "/";
  }, []);

  return (
    <DuviSharedAdminErrorBoundary>
      <DuviSharedAdminAuthProvider config={authConfig}>
        {/* App-level toast bus — mounted ABOVE the router so every routed
            page's behaviour hook (which runs in the page container) can push
            toasts. The shell no longer owns the provider (that placed it below
            the container, where the hook read the no-op default). */}
        <DuviCoreAdminToastProvider>
          <RouterProvider router={router} />
          <DuviSharedAdminSessionExpiredDialog
            open={sessionExpired}
            onConfirm={handleSessionExpiredConfirm}
          />
        </DuviCoreAdminToastProvider>
      </DuviSharedAdminAuthProvider>
    </DuviSharedAdminErrorBoundary>
  );
}
